import React from "react";
import BreadCrumb from "../../layout/BreadCrumb";
import DashHeader from "./DashHeader";
import DashboardFy from "./DashboardFy";

function Dashboard() {
  return (
    <div>
      <BreadCrumb />
      <DashHeader/>
      <DashboardFy/>
    </div>
  );
}

export default Dashboard;
